import mutations from './mutations';

const state = {
    shareTaskList: [],
};

export default {
    namespaced: true,
    state,
    mutations,
};
